import React from 'react';
import { TextField, Grid, Typography, Alert, Button, Box, FormControl, InputLabel, Select, MenuItem} from '@mui/material';
import { useOutletContext, Link as RouterLink } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import { PROVINCES, COUNTRIES } from '../../client/data/countries';

const PersonalDetailsStep = () => {
    const { formData, handleInputChange, errors, profileData } = useOutletContext();
    const displayData = profileData || {};

    return (
        <>
            <Typography variant="h6" gutterBottom>1. Personal Details</Typography>
            
            <Alert severity="info" sx={{ mb: 3 }}>
                Core details are pre-filled from your profile. 
                <Button component={RouterLink} to="/profile" size="small" startIcon={<EditIcon />} sx={{ ml: 1 }}>
                    Update Profile
                </Button>
            </Alert>

            <Grid container spacing={3}>
                {/* Existing Read-Only Fields */}
                <Grid item xs={12} sm={6}><TextField required disabled name="Surname" label="Surname" fullWidth value={displayData.Surname || ''} /></Grid>
                <Grid item xs={12} sm={6}><TextField required disabled name="FirstNames" label="First Names" fullWidth value={displayData.FirstNames || ''} /></Grid>
                <Grid item xs={12} sm={6}><TextField disabled name="IdNumber" label="ID Number" fullWidth value={displayData.IdNumber || ''} /></Grid>
                <Grid item xs={12} sm={6}><TextField disabled name="CellNumber" label="Cellphone" fullWidth value={displayData.CellNumber || ''} /></Grid>

                {/* NEW: Pre-populated Profile Fields (Read Only) */}
                <Grid item xs={12} sm={4}><TextField disabled name="Gender" label="Gender" fullWidth value={displayData.Gender || ''} /></Grid>
                <Grid item xs={12} sm={4}><TextField disabled name="Race" label="Race/Ethnicity" fullWidth value={displayData.Race || ''} /></Grid>
                <Grid item xs={12} sm={4}><TextField disabled name="Province" label="Province" fullWidth value={displayData.Province || ''} /></Grid>

                {/* PROVINCE */}
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth>
                        <InputLabel>Province</InputLabel>
                        <Select name="Province" value={displayData.Province || ''} label="Province" disabled >
                            {PROVINCES.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Grid>
                
                {/* COUNTRY with FLAGS */}
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth>
                        <InputLabel>Country</InputLabel>
                        <Select disabled 
                            name="Country" 
                            value={displayData.Country || 'South Africa'} 
                            label="Country"
                            renderValue={(selected) => {
                                // Optional: Show flag in the input box too
                                const c = COUNTRIES.find(x => x.label === selected);
                                return c ? `${c.flag} ${c.label}` : selected;
                            }}
                        >
                            {COUNTRIES.map(c => (
                                <MenuItem key={c.code} value={c.label}>
                                    <span style={{ marginRight: '10px', fontSize: '1.2rem' }}>{c.flag}</span>
                                    {c.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                
                {/* Application Specific Email */}
                <Grid item xs={12}>
                    <TextField
                        required
                        name="email"
                        label="Contact Email for this Application"
                        type="email"
                        fullWidth
                        value={formData.personal.email || ''}
                        onChange={(e) => handleInputChange('personal', e)}
                        error={!!errors.email}
                        helperText={errors.email}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default PersonalDetailsStep;